import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, PermissionService } from '../services';

@Injectable()
export class AppAuthGuard  {
  
  constructor(
    protected router: Router, 
    private authService: AuthService,
    private permissionService: PermissionService
  ){ }

  
  /**
   * 
   * @param route 
   * @param state 
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLoggedIn = this.authService.isLoggedIn();
    console.log('[AUTH_GUARD] canActivate', { url: state.url, isLoggedIn });

    if(isLoggedIn){
      return true;
    }
    else{
      console.warn('[AUTH_GUARD] blocked, redirect /login', { url: state.url });
      return this.router.parseUrl('/login');
    }
  }
}